import { Label } from 'design-system/label'
import styled from 'styled-components'

export const DropdownLabel = styled(Label)`
  font-size: ${p => p.theme.bodySizes.BODY1};
  font-weight: 500;
  color: ${p => p.theme.colors.gray0};
`
